import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-permission-role-list',
  templateUrl: './user-permission-role-list.component.html',
  styleUrls: ['./user-permission-role-list.component.less']
})
export class UserPermissionRoleListComponent implements OnInit {
  private scope: string;

  constructor(
    private router: Router,
  ) { }

  ngOnInit() {
    this.scope = "edition";
    this.setElementAttributes();
  }

  private setElementAttributes() {
    const element = document.getElementById("user-permission-role-list");

    element.setAttribute("scope", this.scope);
  }

  public handleOpenUserRole(event: Event) {
    const [role] = event['detail'];
    this.router.navigate(["/global-settings/permissions", role]);
  }

  public handleAddUsersToRole(event: Event) {
    console.log("adding");
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-settings/permission-settings/user-permission-role-list.component.ts